import type { DrawerDetails } from '@/types';
import type { FC } from 'react';

import DrawerDetailsRow from '@/components/drawers/item-drawer/drawer-details-row';
import LockPinButton from '@/components/shared/lock-pin-button';

const DrawerContent: FC<{
  details: DrawerDetails[];
  isLocked: boolean;
  onToggleLock: () => void;
}> = ({ details, isLocked, onToggleLock }) => (
  <div className="px-4 pb-4 flex justify-between ">
    <div className="flex flex-col gap-2">
      {details.map(({ type, content, deviation }) => (
        <DrawerDetailsRow key={type} type={type} content={content} deviation={deviation} />
      ))}
    </div>
    <LockPinButton isLocked={isLocked} onClick={onToggleLock} />
  </div>
);

export default DrawerContent;
